import * as React from "react";
import {observer} from "mobx-react";

import "./message-box.scss";

import {Button, Card, Progress} from "semantic-ui-react";
import {IAppStore, withStore} from "../../stores/abstract-app-store";

export interface MessageBoxProps {
    store?: IAppStore; // this is injected by withStore
}

@observer
class MessageBoxBase extends React.Component<MessageBoxProps, any> {

    constructor(props: MessageBoxProps) {
        super(props);
    }

    /**
     * Update progress bar
     */
    progress(percent: number) {
        if (percent < 0) {
            percent = 0;
        }
        if (percent > 100) {
            percent = 100;
        }
        this.setState(() => ({
            percent,
        }));
    }

    render() {
        const {store} = this.props;
        if (!store) {
            return;
        }

        const {
            type,
            show,
            percent,
            title,
            subTitle,
            message,
            hasProgress,
            okButton,
            cancelButton
        } = store.appStore.messageBox;

        if (!show) {
            return null;
        }

        const showFooter = hasProgress || okButton || cancelButton;
        const css = `ui top aligned geo-component geo-widget geo-popup geo-popup--shadow geo-message-box ${type}`;
        return (
            <div className={css}>
                <Card className={type}>
                    <Card.Content>
                        <Card.Header>{title}</Card.Header>
                        {subTitle &&
                        <Card.Meta>
                            <span className="date">{subTitle}</span>
                        </Card.Meta>
                        }
                        <Card.Description>
                            {message}
                        </Card.Description>
                    </Card.Content>
                    {showFooter &&
                    <Card.Content extra>
                        {hasProgress &&
                        <Progress className="geo-message-box-progress" active
                            percent={percent} progress="percent" autoSuccess size="small" color="blue"/>
                        }
                        {okButton &&
                        <Button compact
                            onClick={store.appStore.closeMessageBox.bind(store.appStore)}>
                            OK
                        </Button>
                        }
                        {cancelButton &&
                        <Button compact basic
                            onClick={store.appStore.closeMessageBox.bind(store.appStore)}>
                            Abbrechen
                        </Button>
                        }
                    </Card.Content>
                    }
                </Card>
            </div>
        );
    }
}

export const MessageBox = withStore(MessageBoxBase);
